<template>
    <div class="card bestprod-card" >
        <div class="bestprod-card__top">
            <div class="bestprod-card__bage"
                 :class="card.status"
                 v-if="card.status"
            >
                {{card.status}}
            </div>
            <img :src="require('@/assets/img/cat2.svg')" alt="" @click="goToRoute()">
            <div class="bestprod-card__actions">
                <div class="add-favorite">
                    <heart-icon size="24" class="svg-fill"></heart-icon>
                </div>
                <div class="add-cart">
                    <shopping-cart-icon size="24"></shopping-cart-icon>
                </div>
            </div>
        </div>
        <div class="bestprod-card__info">
            <div class="bestprod-card__title">
                {{ card.title }}
            </div>
            <div class="bestprod-card__range">
                <range-bar
                        :sold="card.sold"
                        :amount="card.amount"
                ></range-bar>
            </div>
            <div class="bestprod-card__price">
                <card-price
                        :current="card.price.curr"
                ></card-price>
            </div>
        </div>
    </div>
</template>

<script>
    import RangeBar from "../Helpers/RangeBar";
    import CardPrice from "../Helpers/CardPrice";

    import { ShoppingCartIcon, HeartIcon} from 'vue-feather-icons';
    export default {
        name: "BestProductCard",
        props: {
            card: {
                type: Object,
                default: () => {}
            }
        },
        components: {
            CardPrice,
            RangeBar,
            ShoppingCartIcon,
            HeartIcon
        },
        methods: {
            goToRoute() {
                this.$router.push('product-page');
            }
        }
    };
</script>

<style scoped lang="scss">
    .bestprod-card {
        display: flex;
        flex-direction: column;
        flex: 1;
        height: 384px;
        width: 280px;
        margin-bottom: 32px;
        &__top {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 280px;
            width: 280px;
            box-shadow: 0 2px 15px rgba(0, 0, 0, 0.05);
            border-radius: 5px;
            position: relative;
            cursor: pointer;
            &:hover {
                box-shadow: 0 2px 20px rgba(0, 0, 0, 0.3);
                transition: all .4s ease;
                .bestprod-card__actions {
                    display: flex;
                    opacity: 1;
                    animation: show-controls .5s ease-out;
                }
            }
        }
        @keyframes show-controls {
            0% {
                display: none;
                opacity: 0;
            }

            1% {
                display: flex;
                opacity: 0;
            }

            100% {
                display: block;
                opacity: 1;
            }
        }
        &__bage {
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 5px 0 0 0;
            color: #FCFCFC;
            font-size: 12px;
            height: 24px;
            width: 40px;
            text-transform: capitalize;
            position: absolute;
            left: 0;
            top: 0;
            &.new {
                background-color: #1DD1A1;
            }
            &.sale {
                background: #EE5253;
            }
        }
        &__actions {
            /*display: flex;*/
            align-items: center;
            position: absolute;
            bottom: 0;
            right: 0;
            display: none;
            opacity: 0;
            > div {
                display: flex;
                justify-content: center;
                align-items: center;
                height: 40px;
                width: 40px;
                cursor: pointer;
            }
            .add-favorite {
                color: #7AC3C1;
                margin-right: 5px;
            }
            .add-cart {
                background: linear-gradient(86.51deg, #7AC3C1 0%, #3FB0AB 100%);
                border-radius: 0 0 5px 0;
                color: #FCFCFC;
            }
        }
        &__info {
            margin-top: 12px;
        }
        &__title {
            font-size: 18px;
            color: #3F4450;
        }
        &__range {
            margin-top: 8px;
        }
        &__price {
            margin-top: 8px;
        }
    }
</style>
